<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="名称"
        v-model="listQuery.name"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="编号"
        v-model="listQuery.code"
      >
      </el-input>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-if="businessType === 0"
        v-model="listQuery.category"
      >
        <el-option label="车系归属" :value="99"> </el-option>
        <el-option label="王朝" :value="1"> </el-option>
        <el-option label="海洋" :value="2"> </el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="info"
        icon="el-icon-search"
        @click="doSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset"
        >重置</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="doRefreshCache"
        >刷新缓存</el-button
      >
      <!-- <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showNewDialog'>添加</el-button> -->
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      fit
      border
      highlight-current-row
      style="width: 100%"
      max-height="600"
      row-key="id"
      :tree-props="{children: 'specs', hasChildren: 'hasChildren'}"
    >
      <el-table-column align="left" label="车型车系编号" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车型车系名称" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="类型" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="归属" width="60">
        <template slot-scope="scope">
          <span>{{ scope.row.category | categoryDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="分类" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.reportType | reportTypeDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车系组" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.groupName }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="报表统计" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.needReport ? "统计" : "不统计" }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="是否预售" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.isPreSale ? "预售" : "非预售" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="排序" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || '' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        align="center"
        label="状态"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status | statusDisplay
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.specs" size="mini" @click="showOnlineDialog(scope.row)"
            >映射</el-button
          >
          <!-- <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="添加车系" :visible.sync="newDialogVisible" width="400px">
      <el-form
        ref="newForm"
        :model="newForm"
        :rules="newFormRules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="车系编号" prop="code">
          <el-input
            style="width: 120px"
            v-model="newForm.code"
            placeholder="车系编号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="上传车辆图片">
          <el-upload class="avatar-uploader" accept=".jpg,.png" action ref="upload1" :on-change="changeUpload1"
            :http-request="iconUploadRequest2" :show-file-list="false" :auto-upload="false" :before-upload="beforeUpload">
            <img v-if="newForm.picUrl != ''" :src="newForm.picUrl" class="avatar avatar1" />
            <i v-if="newForm.picUrl != ''" class="el-icon-delete delete" @click.stop="imgDelete1"></i>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="车系名称" prop="name">
          <el-input
            style="width: 200px"
            v-model="newForm.name"
            placeholder="车系名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="车系组">
          <el-input
            style="width: 200px"
            v-model="newForm.groupName"
            placeholder="车系组"
          ></el-input>
        </el-form-item>
        <el-form-item label="车系类型" prop="type">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="newForm.type"
          >
            <el-option label="燃油车" value="燃油车"> </el-option>
            <el-option label="纯电动" value="纯电动"> </el-option>
            <el-option label="混动" value="混动"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车系归属" v-if="businessType === 0">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="newForm.category"
          >
            <el-option label="王朝" :value="1"> </el-option>
            <el-option label="海洋" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="newForm.reportType"
          >
            <el-option label="请选择" :value="0"> </el-option>
            <el-option label="新车" :value="1"> </el-option>
            <el-option label="热门" :value="2"> </el-option>
            <el-option label="其他" :value="3"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否统计">
          <el-switch v-model="newForm.needReport"> </el-switch>
        </el-form-item>
        <el-form-item label="是否预售">
          <el-switch v-model="newForm.isPreSale"> </el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            style="width: 120px"
            v-model="newForm.sort"
            placeholder="排序"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="editData.isModel ? '编辑车型' : '编辑车系'" :visible.sync="editDialogVisible" width="400px">
      <el-form
        ref="editForm"
        :model="editData"
        :rules="newFormRules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="车系编号">
          <el-input
            style="width: 120px"
            v-model="editData.code"
            placeholder="车系编号"
            disabled
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="上传车辆图片">
          <el-upload class="avatar-uploader" accept=".jpg,.png" action ref="upload2" :on-change="changeUpload1"
            :http-request="iconUploadRequest3" :show-file-list="false" :auto-upload="false" :before-upload="beforeUpload">
            <img v-if="editData.picUrl != ''" :src="editData.picUrl" class="avatar avatar1" />
            <i v-if="editData.picUrl != ''" class="el-icon-delete delete" @click.stop="imgDelete2"></i>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="车系名称">
          <el-input
            style="width: 200px"
            v-model="editData.seriesName"
            placeholder="车系名称"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="车型名称" v-if="editData.isModel">
          <el-input
            style="width: 200px"
            v-model="editData.modelName"
            placeholder="车型名称"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            style="width: 120px"
            v-model="editData.sort"
            :min="1"
            :max="99999"
            placeholder="排序"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="车系组">
          <el-input
            style="width: 200px"
            v-model="editData.groupName"
            placeholder="车系组"
          ></el-input>
        </el-form-item>
        <el-form-item label="车系类型" prop="type">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="editData.type"
          >
            <el-option label="燃油车" value="燃油车"> </el-option>
            <el-option label="纯电动" value="纯电动"> </el-option>
            <el-option label="混动" value="混动"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车系归属" v-if="businessType === 0">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="editData.category"
          >
            <el-option label="王朝" :value="1"> </el-option>
            <el-option label="海洋" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select
            style="width: 200px"
            class="filter-item"
            v-model="editData.reportType"
          >
            <el-option label="请选择" :value="0"> </el-option>
            <el-option label="新车" :value="1"> </el-option>
            <el-option label="热门" :value="2"> </el-option>
            <el-option label="其他" :value="3"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否统计">
          <el-switch v-model="editData.needReport"> </el-switch>
        </el-form-item>
        <el-form-item label="是否预售">
          <el-switch v-model="editData.isPreSale"> </el-switch>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-col :span="8">
            <el-select
              style="width: 200px"
              class="filter-item"
              v-model="editData.status"
            >
              <el-option label="正常" :value="0"> </el-option>
              <el-option label="冻结" :value="-1"> </el-option>
            </el-select>
          </el-col>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="btnDisabled" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="映射配置" :visible.sync="onlineDialogVisible" width="40%">
      <el-form
        ref="editForm"
        :model="editData"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="车系编号">
          {{ editData.code }}
        </el-form-item>
        <el-form-item label="车系名称">
          {{ editData.name }}
        </el-form-item>
        <el-form-item
          v-for="(item, index) in editData.mappings"
          :key="index"
          :label="item.name"
        >
          <el-input
            style="width: 350px"
            v-model="item.code"
            placeholder="映射编号"
          ></el-input>
          <!-- <el-input style="width: 200px" v-model="item.mapName" placeholder="映射名称"></el-input> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdateOnlines">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="图片剪裁"
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @closed="logCancel"
      append-to-body
      width="70%"
    >
      <div class="cropper-content" v-if="dialogVisible">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :full="option.full"
            :enlarge="option.enlarge"
            :mode="option.mode"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import oss from "@/utils/ali-oss";

export default {
  name: "VehicleSeriesList",
  data() {
    return {
      businessType: store.getters.user.businessType,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        code: "",
        status: 99,
        needReport: 99,
        isPreSale: 99,
        category: 99,
      },

      newDialogVisible: false,
      newForm: {
        name: "",
        code: "",
        type: "",
        needReport: false,
        isPreSale: false,
        groupName: "",
        sort: 0,
        category: 1,
        reportType: 0,
        // picUrl: ""
      },
      editDialogVisible: false,
      editData: {
        sort: 1,
      },

      newFormRules: {
        code: [
          {
            required: true,
            message: "请输入车系编码",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入车系名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择车系类型",
            trigger: "blur",
          },
        ],
      },

      onlineDialogVisible: false,
      fileinfo: "",
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 109, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [200, 109], // 截图框的宽高比例
        canMove: false, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: false, // 是否输出原图比例的截图
        enlarge: "1", // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式
      },
      uploadFile: "",
      btnDisabled: false
    };
  },
  filters: {
    categoryDisplay(type) {
      const map = {
        1: "王朝",
        2: "海洋",
        3: "领汇"
      };
      return map[type];
    },
    statusFilter(status) {
      const statusMap = {
        0: "success",
        1: "info",
      };
      return statusMap[status];
    },
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        "-1": "冻结",
      };
      return statusMap[status];
    },
    onlineOrderDisplay(flag) {
      const map = {
        true: "开放",
        false: "限制",
      };
      return map[flag];
    },
    reportTypeDisplay(type) {
      const map = {
        0: "",
        1: "新车",
        2: "热门",
        3: "其他",
      };
      return map[type];
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
  },
  methods: {
    doReset() {
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        name: "",
        code: "",
        status: 99,
        needReport: 99,
        isPreSale: 99,
        category: 99,
      };
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/seriesList", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          name: this.listQuery.name,
          code: this.listQuery.code,
          useMap: true,
          needReport: this.listQuery.needReport,
          isPreSale: this.listQuery.isPreSale,
          category: this.listQuery.category,
        })
        .then(function (response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showNewDialog() {
      this.newDialogVisible = true;
      this.newForm = {
        code: "",
        name: "",
        type: "",
        needReport: false,
        isPreSale: false,
        groupName: "",
        sort: 0,
        category: 1,
        picUrl: "",
      };
      if (this.$refs["newForm"]) {
        this.$refs["newForm"].resetFields();
      }
    },
    showEditDialog(row) {
      let data = JSON.parse(JSON.stringify(row));
      const { id, code, name, sort, seriesName = '', specs, status, seriesCode = '' } = data
      const isModel = !specs
      this.editData = {
        code: isModel ? seriesCode : code,
        id,
        seriesName: isModel ? seriesName : name,
        modelName: isModel ? name : '',
        sort,
        status,
        isModel,
      };
      this.editDialogVisible = true;
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    doAdd() {
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          this.$httpAuth
            .post("/v1/backendVehicleRpc/addSeries", this.newForm)
            .then(function (response) {
              parent.getList();
              parent.$notify({
                title: "提示",
                message: "保存成功",
              });
              parent.newDialogVisible = false;
            });
        }
      });
    },
    doUpdate() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.btnDisabled = true;
          const { id, sort, status, isModel } = this.editData
          const url = isModel ? "v1/backendVehicleRpc/updateSpecStatus" : "/v1/backendVehicleRpc/updateSeriesStatus";
          this.$httpAuth
            .post(url, {
              id,
              sort,
              status,
            })
            .then((response) => {
              this.getList();
              this.$notify({
                title: "提示",
                message: "保存成功",
              });
              this.editDialogVisible = false;
            }).finally(() => { this.btnDisabled = false;});
        }
      });
    },
    showOnlineDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.onlineDialogVisible = true;
    },
    doUpdateOnlines() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/updateSeriesMapping", {
          id: this.editData.id,
          records: this.editData.mappings,
        })
        .then(function (response) {
          console.log(response.data);
          parent.$notify({
            title: "提示",
            message: "保存成功",
          });
          parent.onlineDialogVisible = false;
          parent.getList();
        });
    },
    toDelete(id) {
      this.$confirm("是否删除该数据?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendVehicleRpc/deleteSeries", {
            id: id,
          })
          .then(function (response) {
            parent.$message({
              message: "删除成功",
              type: "success",
            });
            parent.getList();
          });
      });
    },
    doRefreshCache() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/refreshSeriesCache", {})
        .then(function (response) {
          parent.$message({
            message: "刷新缓存成功",
            type: "success",
          });
        });
    },
    changeUpload1(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      }
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (e) => {
          this.option.img = e.target.result;
          this.dialogVisible = true;
        };
      });
    },
    iconUploadRequest2(option) {
      option.file = this.dataURLtoFile(this.uploadFile, this.fileinfo.name);
      oss.ossUploadFile(option, 0).then((res) => {
        this.newForm.picUrl = res;
      });
    },
    iconUploadRequest3(option) {
      option.file = this.dataURLtoFile(this.uploadFile, this.fileinfo.name);
      oss.ossUploadFile(option, 0).then((res) => {
        this.editData.picUrl = res;
      });
    },
    beforeUpload(file) {
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPEG && !isJPG && !isPNG) {
        this.$message.error("请上传JPEG/JPG/PNG 的图片!");
      }
      if (!isLt2M) {
        this.$message.error("上传的封面大小不能超过5MB!");
      }
      return (isJPEG || isJPG || isPNG) && isLt2M;
    },
    cancel() {
      this.dialogVisible = false;
    },
    logCancel() {
      if (this.editDialogVisible) {
        this.$refs.upload2.clearFiles();
      } else {
        this.$refs.upload1.clearFiles();
      }
    },
    // 将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let len = bstr.length;
      let u8arr = new Uint8Array(len);
      while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        // 把图片上传到服务器
        setTimeout(() => {
          this.dialogVisible = false;
          this.uploadFile = data;
          if (this.editDialogVisible) {
            this.$refs.upload2.submit();
          } else {
            this.$refs.upload1.submit();
          }
        }, 1000);
      });
    },
    imgDelete1() {
      this.newForm.picUrl = "";
    },
    imgDelete2() {
      this.editData.picUrl = "";
    },
  },
};
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}

.cropper {
  width: auto;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-upload .delete {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.avatar {
  width: 200px;
  height: 109px;
  display: block;
}
</style>
